"use strict";
/**
 * @author: yangqianjun
 * @file: ajax 常量
 * @Date: 2019-12-06 18:32:12
 * @LastEditors: yangqianjun
 * @LastEditTime: 2019-12-18 15:47:08
 */
Object.defineProperty(exports, "__esModule", { value: true });
/** 取消请求错误码 */
exports.AjaxCancelCode = 10499;
exports.AjaxCancelMessage = 'AJAX_CANCEL_MESSAGE';
/** 默认Ajax错误码  */
exports.AjaxErrorCode = 10001;
/** 无法确认的 Graphql 错误码 */
exports.GraphQLErrorCode = 10002;
exports.promiseFactory = function () {
    var resolve, reject;
    var prom = new Promise(function (rs, rj) {
        resolve = rs;
        reject = rj;
    });
    var rj = { reject: reject, resolve: resolve };
    return [rj, prom];
};
//# sourceMappingURL=consts.js.map